export default "__VITE_ASSET__a4216aa2__"